exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".up-box[data-v-39c304b4]{display:flex}.up-box img[data-v-39c304b4]{width:360px;height:180px;margin-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-39c304b4&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/UploadDragImg.vue
// module id = 497
// module chunks = 0